<template>
  <div class="news-list">
    <div class="news" @click="goDetail(item)" v-for="(item, index) in list" :key="index">
      <div v-if="item.contentType === 0">
        <div v-if="item.match" class="union-match-info">
          <img class="icon" :src="imageView(item.match.icon)" alt="">
          <div class="name">{{ item.match.chineseName }}</div>
        </div>
        <div class="news-info">
          <div class="left">
            <div class="news-name">
              <span v-if="item.seq > 0">置顶</span>
              <span v-if="item.type === 1">公告</span>
              {{ item.title }}
            </div>
            <div class="tags" v-if="item.tags && item.tags.length > 0">
              <div class="tag" :style="{ 'margin-left': index > 0 ? '5px' : '0' }"
                v-for="(item, index) in item.tags.split(',')" :key="index">{{ item }}</div>
            </div>
          </div>
          <div class="right">
            <img :src="imageView(item.poster, 90, 68)">
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="item.match" class="union-match-info">
          <img class="icon" :src="imageView(item.match.icon)" alt="">
          <div class="name">{{ item.match.chineseName }}</div>
        </div>
        <video :poster="imageView(item.poster, 180, 108)" :src="originView(item.video)" width="100%" controls
          preload></video>
        <div class="news-info">
          <div class="left">
            <div class="news-name">
              <span v-if="item.seq > 0">置顶</span>
              {{ item.title }}
            </div>
            <div class="tags">
              <div class="tag" :style="{ 'margin-left': index > 0 ? '5px' : '0' }"
                v-for="(item, index) in item.tags.split(',')" :key="index">{{ item }}</div>
            </div>
          </div>
          <div class="right">
            <img :src="imageView(item.poster, 90, 68)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCrmNewsList, getCrmAccountHome } from "@/api/match";
import { QNImageUtil } from "@/utils";
export default {
  data() {
    return {
      accountId: '',
      list: []
    }
  },
  mounted() {
    this.accountId = this.$route.params.accountId
    this.getCrmNewsList()
    this.getCrmAccountHome()
  },
  methods: {
    getCrmNewsList() {
      const params = {
        accountId: this.accountId
      }
      getCrmNewsList(params).then(res => {
        if (res) {
          const { data } = res
          this.list = data.list
        }
      })
    },
    imageView(img, w, h) {
      if (!img) return ''
      return QNImageUtil.imageView(img, w, h)
    },
    originView(video) {
      if (!video) return ''
      return QNImageUtil.originView(video)
    },
    goDetail(item) {
      this.$router.push('/account/news-detail/' + item.id)
    },
    getCrmAccountHome() {
      const params = {
        accountId: this.accountId
      }
      getCrmAccountHome(params).then(res => {
        const { data } = res
        const account = data.account || {}
        document.title = account.name
        const shareObj = {
          title: account.name,
          abstract: account.remark,
          image: QNImageUtil.imageView(account.logo)
        }
        this.wxShare(shareObj)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.news-list {
  .news {
    padding: 16px 12px;
    border-bottom: 1px #F3F3F3 solid;

    .union-match-info {
      display: flex;

      .icon {
        width: 16px;
        height: 16px;
      }

      .name {
        color: #757575;
        font-size: 12px;
        margin-left: 6px;
      }
    }

    .news-info {
      display: flex;
      justify-content: space-between;

      .left {
        width: calc(100vw - 126px);

        .news-name {
          span {
            display: inline-block;
            width: 40px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            background-color: #1649F6;
            color: #FFFFFF;
            font-size: 11px;
            border-radius: 2px;
            margin-right: 3px;
          }

          font-size: 16px;
          line-height: 24px;
          color: #282828;
          font-weight: 500;
          overflow:hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }

        .tags {
          display: flex;

          .tag {
            padding: 3px 8px;
            color: #1565FC;
            background-color: #EBF2FF;
            font-size: 11px;
          }
        }
      }

      .right {
        img {
          width: 90px;
          height: 68px;
          overflow: hidden;
          border-radius: 4px;
          object-fit: cover;
        }
      }
    }
  }
}
</style>